import { Component } from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../../common/subscribe/subscribe.component";

@Component({
  selector: 'app-kontakt',
  standalone: true,
    imports: [
        RouterLink,
        SubscribeComponent
    ],
  templateUrl: './kontakt.component.html',
  styleUrl: './kontakt.component.scss'
})
export class KontaktComponent {

}
